module.exports = __webpack_public_path__ + "img/home-cover.b626ede3.png";